import React, { useState, useEffect } from 'react'
import { getData, postData } from '../../../actions/servicesHttp'
import Button from 'react-bootstrap/Button'
import stylesPreferences from '../../../css/preferences/Preferences.module.css'
import stylesIndex from '../../../css/Index.module.css'
import { compareObj } from '../../../components/generals/toolsFunctions'
import Swal from 'sweetalert2'
import store from '../../../reducer/store'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Tooltip } from 'primereact/tooltip'

export default function RSPreferences () {
  // ? urls de la API cuco
  const [rxartPreferencesUrl] = useState('rxartsecure/preferences')
  const [urlDownloadActivationCodes] = useState('rxartsecure/license-activation-codes')
  const [urlSynchronizeLicenses] = useState('rxartsecure/synchronize-licenses')
  const [urlProcessPdf] = useState('process-pdf')
  const [RSPreferences, setRSPreferences] = useState()
  const [preferencesToCompare, setPreferencesToCompare] = useState({})
  const { user } = store.getState()
  const role = user.roles
  const { t } = useTranslation('rxartPreferences')
  const navigate = useNavigate()

  const handleInputChange = (e) => {
    if (e.target.name === 'iniTimeout' || e.target.name === 'maxUsesDay' || e.target.name === 'advertensesDay' || e.target.name === 'maxBoot' || e.target.name === 'checkInterval' || e.target.name === 'checkConfig' || e.target.name === 'expirationDay') {
      setRSPreferences({
        ...RSPreferences,
        [e.target.name]: parseInt(e.target.value)
      })
    } else {
      setRSPreferences({
        ...RSPreferences,
        [e.target.name]: e.target.value
      })
    }
  }

  const requestRS = async (url, body, set, setCompare, method) => {
    try {
      const response = method === 'GET' ? await getData(url, undefined, navigate) : await postData(url, body, navigate)

      if (response.status === 200) {
        if (method === 'GET') {
          set(response?.data)
          setCompare(response?.data)
        } else {
          const res = await getData(url, undefined, navigate)
          if (res.status === 200) {
            set(res?.data)
            setCompare(res?.data)
          } else {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: `${t('message1')} ${method === 'GET' ? t('message2') : t('message3')} ${t('message4')}`,
              showConfirmButton: false,
              timer: 2000
            })
          }
        }

        if (method === 'POST') {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: t('message5'),
            showConfirmButton: false,
            timer: 1500
          })
        }
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: `${t('message1')} ${method === 'GET' ? t('message2') : t('message3')} ${t('message4')}`,
          showConfirmButton: false,
          timer: 2000
        })
      }
    } catch (error) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: t('message6'),
        showConfirmButton: false,
        timer: 2000
      })
    }
  }

  useEffect(() => {
    const body = JSON.stringify({})
    requestRS(rxartPreferencesUrl, body, setRSPreferences, setPreferencesToCompare, 'GET')
  }, [rxartPreferencesUrl])

  const saveRSPreferences = (preferences, preferencesToCompare) => {
    const comparation = compareObj(preferences, preferencesToCompare)

    if (comparation) {
      Swal.fire({
        position: 'center',
        icon: 'info',
        title: t('message7'),
        showConfirmButton: false,
        timer: 1500
      })
    } else {
      const body = {
        ...preferences,
        type: 'project'
      }

      requestRS(rxartPreferencesUrl, body, setRSPreferences, setPreferencesToCompare, 'POST')
    }
  }

  const handleDownload = async (url, namePdf) => {
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf'
        }
      })

      if (!response.ok) {
        throw new Error('Error al descargar el archivo')
      }

      const blob = await response.blob()
      const blobUrl = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = blobUrl
      link.setAttribute('download', `${namePdf}.pdf`)
      document.body.appendChild(link)
      link.click()
      link.remove()

      window.URL.revokeObjectURL(blobUrl)
    } catch (error) {
      console.error('Error en la descarga:', error)
    }
  }

  const LicenseActivationCodesDownload = async (url1, url2, navigate) => {
    const column = [{ field: 'activationCode', header: t('header') }]
    const colJson = column.map(obj => [obj.header, obj.field])
    const namePdf = t('namePdf')
    let flag = false

    Swal.fire({
      text: t('message8'),
      icon: 'info',
      showConfirmButton: false,
      timer: 2000
    })

    const response = await getData(url1, undefined, navigate)

    if (response?.status === 200) {
      const json = {
        title: namePdf,
        columnName: colJson,
        data: response?.data?.activationCodes
      }

      const res = await postData(url2, json, navigate)
      if (res?.status === 200) {
        handleDownload(res.data.url, namePdf)
      } else {
        flag = true
      }
    } else {
      flag = true
    }

    if (flag) {
      Swal.fire({
        text: t('message9'),
        icon: 'error',
        showConfirmButton: false,
        timer: 2000
      })
    }
  }

  const synchronizeLicenses = async (route) => {
    Swal.fire({
      title: t('message10'),
      text: t('message11'),
      icon: 'info'
    })
    const res = await postData(route)

    if (res.status === 200) return true
    return false
  }

  const items = [
    {
      label: t('label3'),
      text: t('description2'),
      inputName: 'advertensesDay',
      tooltipClass: 'message'
    },
    {
      label: t('label2'),
      text: t('description1'),
      inputName: 'maxUsesDay',
      tooltipClass: 'message'
    },
    {
      label: t('label4'),
      text: t('description3'),
      inputName: 'maxBoot',
      tooltipClass: 'message'
    },
    {
      label: t('label5'),
      text: t('description4'),
      inputName: 'checkInterval',
      tooltipClass: 'message'
    },
    {
      label: t('label9'),
      text: t('description5'),
      inputName: 'checkConfig',
      tooltipClass: 'message'
    }
  ]

  return (
    <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
      <div className={`content  ${stylesIndex.mainContent}`}>
         <div className={stylesPreferences.headerContent}>
                  <i className={`fas fa-shield-alt ${stylesPreferences.iconHeader}`}></i>
                  <div>
                    <p className={stylesPreferences.pTitle}>{t('title')}</p>
                    <p className={stylesPreferences.pSubTitle}>{t('subtitle')}</p>
                  </div>
                </div>
                <div className={stylesPreferences.globalContainer}>
                  {role?.preferencesRxartSecurePage.parameters && <div className={stylesPreferences.parametersContainerFlex}>
                    <div className={stylesPreferences.parametersContainer}>
                      <div className={`${stylesPreferences.headerContent} ${stylesPreferences.borderBottom} ${stylesPreferences.padding}`}>
                        <i className={`fas fa-stream ${stylesPreferences.iconSettings}`}></i>
                        <div>
                          <p className={stylesPreferences.pTitleSecondary}>{t('label1')}</p>
                          <p className={stylesPreferences.pSubTitleSecondary}>{t('label13')}</p>
                        </div>
                        </div>
                      <Tooltip target=".message" />
               {items.map((element, index) => {
                 const input = element.inputName
                 const validateInput = input === 'maxUsesDay' ? RSPreferences?.maxUsesDay : input === 'advertensesDay' ? RSPreferences?.advertensesDay : input === 'maxBoot' ? RSPreferences?.maxBoot : input === 'checkInterval' ? RSPreferences?.checkInterval : RSPreferences?.checkConfig
                 return (
                          <div key={input} className={`${stylesPreferences.inputContainer}`}>
                            <label className={stylesPreferences.labelRS}>
                              {element.label}
                              <i
                                className={`pi pi-exclamation-circle message ${stylesPreferences.iconMessage}`}
                                data-pr-tooltip={`${element.text}`}
                                data-pr-position="top"
                              ></i>
                            </label>
                            <div className={stylesPreferences.inputSpanContainer}>
                              <input
                                className={stylesPreferences.inputRS}
                                type="number"
                                name={element.inputName}
                                value={validateInput}
                                onChange={(e) => handleInputChange(e)}
                                min={1}
                              />
                              <span className={stylesPreferences.spanValue}>{input === 'maxBoot' ? t('label14') : (input === 'checkInterval' || input === 'checkConfig') ? ' min.' : t('label15')}</span>
                            </div>
                          </div>
                 )
               })}
            </div>
            <div className={stylesPreferences.parametersContainer}>
              <div className={`${stylesPreferences.headerContent} ${stylesPreferences.borderBottom} ${stylesPreferences.padding}`}>
                <i className={`fas fa-comment-dots ${stylesPreferences.iconSettings}`}></i>
                <div>
                  <p className={stylesPreferences.pTitleSecondary}>{t('label6')}</p>
                  <p className={stylesPreferences.pSubTitleSecondary}>{t('label16')}</p>
                </div>
                </div>
                 <Tooltip target=".message" />
              <div className={`${stylesPreferences.inputContainerMessage}`}>
                <label className={stylesPreferences.labelRS}>
                    {t('label7')}
                  <i
                    className={`pi pi-exclamation-circle message ${stylesPreferences.iconMessage}`}
                    data-pr-tooltip={t('label17')}
                    data-pr-position="top"
                  ></i>
                </label>
                <textarea
                  name="messagesAdvertense"
                  minLength={11}
                  maxLength={216}
                  value={RSPreferences?.messagesAdvertense ? RSPreferences?.messagesAdvertense : ''}
                  onChange={(e) => handleInputChange(e)}
                  className={`${stylesPreferences.messageTexTarea}`}
                />
              </div>
              <div className={`${stylesPreferences.inputContainerMessage}`}>
                <label className={stylesPreferences.labelRS}>
                    {t('label8')}
                  <i
                    className={`pi pi-exclamation-circle message ${stylesPreferences.iconMessage}`}
                    data-pr-tooltip={t('label18')}
                    data-pr-position="top"
                  ></i>
                </label>
                <textarea
                  name="messagesBlock"
                  minLength={11}
                  maxLength={216}
                  value={RSPreferences?.messagesBlock ? RSPreferences?.messagesBlock : ''}
                  onChange={(e) => handleInputChange(e)}
                  className={`${stylesPreferences.messageTexTarea}`}
                />
              </div>
            </div>
          </div>}
          <div className={`${stylesPreferences.parametersContainer} ${stylesPreferences.fullWidth}`}>
            <div className={`${stylesPreferences.headerContent} ${stylesPreferences.borderBottom} ${stylesPreferences.padding}`}>
                <i className={`fas fa-file-code ${stylesPreferences.iconSettings}`}></i>
                <div>
                  <p className={stylesPreferences.pTitleSecondary}>{t('label19')}</p>
                </div>
            </div>
            <Tooltip target=".message" />
            <div className={stylesPreferences.actionsContainer}>
              <div className={stylesPreferences.actionContainer}>
                <i className={`fas fa-file-code ${stylesPreferences.iconSettings}`}></i>
                <label className={stylesPreferences.labelRS}>
                  {t('label21')}
                  <i
                    className={`pi pi-exclamation-circle message ${stylesPreferences.iconMessage}`}
                    data-pr-tooltip={t('label20')}
                    data-pr-position="top"
                  ></i>
                </label>
                <button className={`${stylesPreferences.btnCode} ${stylesPreferences.btnChangeStatus}`}
                  onClick={() => synchronizeLicenses(urlSynchronizeLicenses)}>
                    <i className={`fa-solid fa-arrows-rotate ${stylesPreferences.iconBtnCode}`}></i>
                    <span className={stylesPreferences.spanBtnCode}>{t('button2')}</span>
                </button>
              </div>
              <div className={stylesPreferences.actionContainer}>
                <i className={`fas fa-file-code ${stylesPreferences.iconSettings}`}></i>
                <label className={stylesPreferences.labelRS}>
                  {t('label22')}
                  <i
                    className={`pi pi-exclamation-circle message ${stylesPreferences.iconMessage}`}
                    data-pr-tooltip={t('label23')}
                    data-pr-position="top"
                  ></i>
                </label>
                <button className={`${stylesPreferences.btnCode} ${stylesPreferences.btnChangeStatus}`}
                  onClick={() => LicenseActivationCodesDownload(urlDownloadActivationCodes, urlProcessPdf)}>
                    <i className={`fas fa-download ${stylesPreferences.iconBtnCode}`}></i>
                    <span className={stylesPreferences.spanBtnCode}>{t('button3')}</span>
                </button>
              </div>
               </div>
          </div>
          <div className={`end-footer-body ${stylesPreferences.btnEnd}`}>
            <Button onClick={() => saveRSPreferences(RSPreferences, preferencesToCompare)} variant="dark">
              <i className="fas fa-save" style={{ marginRight: '0.5rem' }}></i>
              {t('button1')}
            </Button>
        </div>
        </div>
      </div>
    </div>
  )
}
